---
en:
  admin:
    production_periods:
      errors:
        generic: Unable to load production period data.
      filters:
        date: Date
        month: Month
        power_plant: Power plant
        week_start: Week start
        year: Year
      labels:
        data_horizon: Data horizon
        power_plant: Power plant
        settled_source: 'Settled: {source}'
        sources: Sources
        timezone: Timezone
        unknown: Unknown
        unsettled_source: 'Unsettled: {source}'
      missing_segments:
        empty: No missing segments detected for the selected view.
        hours_missing:
          one: "{count} hour missing"
          other: "{count} hours missing"
        title: Missing segments
      summary:
        missing_unknown: No coverage information available.
        settled_hours_label: Settled hours present
        settled_volume_label: Settled volume (MWh)
        unsettled_hours_label: Unsettled hours present
        unsettled_volume_label: Unsettled volume (MWh)
      table:
        hour: Hour
        no_day_data: No hourly values
        no_timeline_data: No timeline data
        selected_series_mwh: Selected series (MWh)
        settled_mwh: Settled (MWh)
        unsettled_mwh: Unsettled (MWh)
      timeline:
        coverage: Coverage
        label: Date
        missing_hours: Missing hours
        settled_coverage: Settled cov.
        settled_hours: Settled hours
        settled_volume: Settled (MWh)
        unsettled_coverage: Unsettled cov.
        unsettled_hours: Unsettled hours
        unsettled_volume: Unsettled (MWh)
      title: Production periods drilldown
